<div class="page-layout carded left-sidenav toolbar-fixed-layout">

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg parent-tab-for-grid">
        <mat-tab-group>
          <mat-tab label="Team drive">
            <ng-template matTabContent>
              <particle-file-manager-grid [sourceType]="sourceType"></particle-file-manager-grid>
            </ng-template>
          </mat-tab>
          <mat-tab label="Shared with me">
            <ng-template matTabContent>
              <particle-shared-with-me></particle-shared-with-me>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </mat-sidenav-container>
</div>
